module.exports = __webpack_public_path__ + "img/banner2-2x.3050c26c.png";